import script from "./UserList.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserList.vue?vue&type=script&lang=ts&setup=true"

import "./UserList.vue?vue&type=style&index=0&id=4f11f728&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f11f728"]])

export default __exports__